import { createRouter, createWebHistory } from 'vue-router';

import LandingPage from '@/views/LandingPage.vue'




//import UserProfile from '@/views/UserProfile.vue';
//import ChangePassword from '@/views/ChangePassword.vue';
//import SubscriptionSuccess from '@/views/SubscriptionSuccess.vue';
//import PaymentPlan from '@/views/PaymentPlan.vue';
//import LandingPage from '@/views/LandingPage.vue';





const routes = [
  {
    path: '',
    name: 'LandingPage',
    component: LandingPage
  },
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
  },
      {
        path: '/signin',
        name: 'SignIn',
        component: LandingPage,
      },
    
  /* {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
  },
  

  {
    path: '/section1training',
    name: 'Section1Training',
    component: Section1Training,
  },

  {
    path: '/section2training',
    name: 'Section2Training',
    component: Section2Training,
  },

  {
    path: '/mockTest',
    name: 'MockTest',
    component: MockTest,
  },

  {
    path: '/scoreReportHistory',
    name: 'scoreReportHistory',
    component: scoreReportHistory,
  },

  {
    path: '/user-metrics',
    name: 'UserMetrics',
    component: UserMetrics,
  },

  {
    path: "/previous-exam/:mock_test_id",
    name: "PreviousExam",
    component: PreviousExam,
  },

  {
    path: "/user-profile",
    name: "UserProfile",
    component: UserProfile,
  },

  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
  },

  {
    path: '/subscription-success',
    name: 'SubscriptionSuccess',
    component: SubscriptionSuccess,
  },

  {
    path: '/payment-plan',
    name: 'PaymentPlan',
    component: PaymentPlan,
  }, */
  
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });

export default router;